import { Property } from './property';

export interface InvestmentProperty extends Property {}
